import { render, staticRenderFns } from "./EventReplyRegister.vue?vue&type=template&id=72ed6af4&scoped=true&lang=pug"
import script from "./EventReplyRegister.vue?vue&type=script&lang=ts"
export * from "./EventReplyRegister.vue?vue&type=script&lang=ts"
import style0 from "./EventReplyRegister.vue?vue&type=style&index=0&id=72ed6af4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed6af4",
  null
  
)

export default component.exports